import { FunctionComponent, useState, useEffect } from 'react'
import {
  Box,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import colors from '../../colors'
import axios from '../../utils/axios'
import { useParams } from 'react-router-dom'

type Props = {
  patronId?: string
}
const BenefitsView: FunctionComponent<Props> = ({ patronId }) => {
  const idFromUrl = useParams().id
  const id = patronId || idFromUrl

  const [fetchingBenefits, setFetchingBenefits] = useState(true)
  const [memberships, setMemberships] = useState([])

  useEffect(() => {
    if (!id) return

    (async () => {
      const resp = await axios.get(`/memberships/${id}/benefits`)
      setMemberships(resp.data)
      setFetchingBenefits(false)
    })()
  }, [id])

  const styles = useStyles()

  if (fetchingBenefits) {
    return (
      <Box>
        loading
      </Box>
    )
  }

  if (!memberships.length) {
    return (
      <Box p={4}>
        <Typography>No benefits found for this membership</Typography>
      </Box>
    )
  }

  return (
    <Box p={4} className={styles.container}>
      <Box mb={4}>
        <Typography variant={"h3"}>Benefits</Typography>
      </Box>
      {memberships.map((benefit: any) => {
        return (
          <Box key={benefit.id} mb={2} p={2} style={{ border: '1px solid #e0e0e0', borderRadius: 4 }}>
            <Typography variant="h6">{benefit.title}</Typography>
            <Typography variant="body2" color="textSecondary">{benefit.details}</Typography>
            <Typography variant="caption">
              Quantity: {benefit.quantity} | Interval: {benefit.interval}
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}

const useStyles = makeStyles({
  tableContainer: {

  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  formContainer: {
    width: '80%',
    maxWidth: 400,
  },
  issueButton: {
    background: colors.PALE_BLUE,
  },
  membershipTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  cancelButton: {
    display: 'inline'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  titleContainer: {
    height: 30,
    display: 'flex',
    justifyContent: 'space-between',
  },
  disabled: {
    fontWeight: 'bold'
  },
  dateBox: {
    display: 'flex',
    flexDirection: 'row',
  },
})

export default BenefitsView
